export default {"src":"/find-tickets/_next/static/media/searching_ticket.5e490afc.svg","height":390,"width":373,"blurWidth":0,"blurHeight":0};